/* eslint-disable */

import orderBy from 'lodash/orderBy';
import { useCallback, useEffect, useMemo, useState } from 'react';
// @mui
import { Grid, Pagination, Stack, Typography } from '@mui/material';
// hooks
import useIsMountedRef from '../../hooks/useIsMountedRef';
import useSettings from '../../hooks/useSettings';
// utils
// routes
// components
import { SkeletonPostItem } from '../../components/skeleton';
// sections
import { useNavigate } from 'react-router';
import { BlogUtils } from '../../api_utils';
import { PATH_PAGE } from '../../routes/paths';
import { BlogPostsSearch, BlogPostsSort } from '../@dashboard/blog';
import BlogPostCard from './blog/BlogPostCard';

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

// ----------------------------------------------------------------------

const applySort = (posts, sortBy) => {
  if (sortBy === 'latest') {
    return orderBy(posts, ['created_at'], ['desc']);
  }
  if (sortBy === 'oldest') {
    return orderBy(posts, ['created_at'], ['asc']);
  }
  if (sortBy === 'popular') {
    return orderBy(posts, ['views'], ['desc']);
  }
  return posts;
};

export default function BlogPosts() {
  const { themeStretch } = useSettings();
  const [loading, setLoading] = useState(true);
  const pageLength = 7;

  const navigate = useNavigate();

  const isMountedRef = useIsMountedRef();

  const [posts, setPosts] = useState([]);

  const [filters, setFilters] = useState('latest');


  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);

  const getAllPosts = useCallback(async () => {
    setLoading(true);
    const res = await BlogUtils.getAllPosts();
    if (res.success) {
      setPosts(res.data);
      setPages(Math.ceil(res.data.length / pageLength).toFixed(0))
      if (res.data.length === 0) {
        document.getElementById('more-home-btn').style.display = "none"
      }
    }
    setLoading(false)
  }, [isMountedRef]);

  useEffect(() => {
    getAllPosts();
  }, [getAllPosts]);

  const handleChangeSort = (value) => {
    if (value) {
      setFilters(value);
    }
  };

  const handleClickPost = (p) => {
    navigate(`${PATH_PAGE.blogPostRoot}${p.id}`)
  }

  const sortedPosts = useMemo(() => {
    return applySort(posts, filters)
  }, [posts, filters])

  const pagePosts = useMemo(() => {
    const pageStart = (page - 1) * pageLength
    return sortedPosts.slice(pageStart, (pageStart) + pageLength)
  }, [sortedPosts, page])

  return (
    <section id="blog-posts">
      <Grid container sx={{ p: 4 }}>
        {/* <Grid item xs={12} md={6} mb={2}>
         <Timeline dataSource={{ sourceType: "profile", screenName: "steincounseling" }} />
        </Grid>
        <Grid item xs={12} md={6} mb={2}>
          <Card>
            <div className="fb-page" data-href="https://www.facebook.com/steincounseling" data-tabs="timeline" data-width="" data-height="" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"><blockquote cite="https://www.facebook.com/steincounseling" className="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/steincounseling">Stein Counseling</a></blockquote></div>
          </Card>        
        </Grid> */}
        {(!loading && posts.length > 0) &&
          <>
            <Grid item xs={12} md={12} mb={2}>
              <Typography variant='h2'>Blog Posts</Typography>
            </Grid>
            <Grid item xs={12} md={6} mb={4}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <BlogPostsSearch posts={sortedPosts} handleClickPost={handleClickPost} />
                <BlogPostsSort query={filters} options={SORT_OPTIONS} onSort={handleChangeSort} />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6} mb={4} display="flex" flexDirection="row" justifyContent="end">
              <Pagination
                count={pages}
                page={page}
                onChange={(e, value) => {
                  setPage(value)
                }}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Grid container spacing={3}>
                {(loading ? [...Array(12)] : pagePosts).map((post, index) =>
                  post ? (
                    <Grid key={`post-${post.id}-${index}`} item xs={12} sm={6} md={(index === 0 && 6) || 3}>
                      <BlogPostCard post={post} index={index} onSelectPost={() => {
                        handleClickPost(post)
                      }} />
                    </Grid>
                  ) : (
                    <SkeletonPostItem key={index} />
                  )
                )}
                {(!posts.length && !loading) &&
                  <Grid item xs={12} md={12}>
                    <Typography variant='h4' textAlign="center">No Blog Posts!</Typography>
                  </Grid>
                }
              </Grid>
            </Grid>
          </>
        }
      </Grid>
    </section>
  );
}
